/**
 * Client portal nav registry — shared by ClientShell and document titles.
 */
import { CalendarDays, FileText, Package, Receipt, Shirt } from "lucide-react";
import type { PortalNavItem } from "@/components/navigation/PortalSidebar";

export const CLIENT_NAV: PortalNavItem[] = [
  {
    key: "catalog",
    path: "/client/catalog",
    label: "Catalog",
    icon: Shirt,
    iconClass: "text-icon-designs",
    capability: "module.my-catalog",
  },
  {
    key: "designs",
    path: "/client/designs",
    label: "My Events",
    icon: CalendarDays,
    iconClass: "text-icon-tasks",
    capability: "module.my-designs",
  },
  {
    key: "quotes",
    path: "/client/quotes",
    label: "My Quotes",
    icon: Receipt,
    iconClass: "text-icon-cash",
    capability: "module.my-quotes",
  },
  {
    key: "orders",
    path: "/client/orders",
    label: "My Orders",
    icon: Package,
    iconClass: "text-icon-products",
    capability: "module.my-orders",
  },
  {
    key: "invoices",
    path: "/client/invoices",
    label: "Invoices",
    icon: FileText,
    iconClass: "text-icon-notes",
    capability: "module.my-invoices",
  },
];
